import React, { ReactNode } from "react";

import Report1Settings from "./reports/Report1/subscription/Settings";
import Report2Settings from "./reports/Report2/subscription/Settings";
import Report3Settings from "./reports/Report3/subscription/Settings";
import Report4Settings from "./reports/Report4/subscription/Settings";
import Report5Settings from "./reports/Report5/subscription/Settings";
import Report6Settings from "./reports/Report6/subscription/Settings";
import Report7Settings from "./reports/Report7/subscription/Settings";
import Report8Settings from "./reports/Report8/subscription/Settings";
import AquariumCropValueSettings from "./reports/AquariumCropValue/subscription/Settings";
import Report9Settings from "./reports/Report9/subscription/Settings";
import Report10Settings from "./reports/Report10/subscription/Settings";
import Report11Settings from "./reports/Report11/subscription/Settings"; // ----
import Report12Settings from "./reports/Report12/subscription/Settings"; // ----
import Report13Settings from "./reports/Report13/subscription/Settings"; //---- emplty selection
import Slide12Settings from "./reports/Slide12/subscription/Settings";
import Slide13Settings from "./reports/Slide13/subscription/Settings";
import Slide15Settings from "./reports/Slide15/subscription/Settings";
import Slide16Settings from "./reports/Slide16/subscription/Settings";
import Slide17Settings from "./reports/Slide17/subscription/Settings";
import Slide18Settings from "./reports/Slide18/subscription/Settings";
import Slide20Settings from "./reports/Slide20/subscription/Settings";
import Slide21Settings from "./reports/Slide21/subscription/Settings";
import Slide23Settings from "./reports/Slide23/subscription/Settings";
import Slide24Settings from "./reports/Slide24/subscription/Settings";
import Slide31Settings from "./reports/Slide31/subscription/Settings";
import Slide32Settings from "./reports/Slide32/subscription/Settings";
import Slide33Settings from "./reports/Slide33/subscription/Settings";
import Slide34Settings from "./reports/Slide34/subscription/Settings";
import Slide35Settings from "./reports/Slide35/subscription/Settings";
import Slide36Settings from "./reports/Slide36/subscription/Settings";

const slidesSettings = new Map<string, JSX.Element>([
  ["slide1", <Report1Settings />],
  ["slide2", <Report2Settings />],
  ["slide3", <Report7Settings />],
  ["slide4", <Report8Settings />],
  ["slide7", <AquariumCropValueSettings />],
  ["slide25", <Report5Settings />],
  ["slide5", <Report3Settings />],
  ["slide6", <Report4Settings />],
  ["slide26", <Report6Settings />],
  ["slide8", <Report9Settings />],
  ["slide9", <Report10Settings />],
  ["slide10", <Report11Settings />],
  ["slide11", <Report12Settings />],
  ["slide14", <Report13Settings />],
  ["slide12", <Slide12Settings />],
  ["slide13", <Slide13Settings />],
  ["slide15", <Slide15Settings />],
  ["slide16", <Slide16Settings />],
  ["slide17", <Slide17Settings />],
  ["slide18", <Slide18Settings />],
  ["slide20", <Slide20Settings />],
  ["slide21", <Slide21Settings />],
  ["slide23", <Slide23Settings />],
  ["slide24", <Slide24Settings />],
  ["slide31", <Slide31Settings />],
  ["slide32", <Slide32Settings />],
  ["slide33", <Slide33Settings />],
  ["slide34", <Slide34Settings />],
  ["slide35", <Slide35Settings />],
  ["slide36", <Slide36Settings />],
]);

export const SubscriptionsSettings: React.FC<{ reportId: string }> = (props) => {
  const { reportId } = props;

  const SettingsComponent = React.useMemo<ReactNode>(() => {
    switch (reportId) {
      case "slide-36":
        return slidesSettings.get("slide36");
      case "slide-35":
        return slidesSettings.get("slide35");
      case "slide-34":
        return slidesSettings.get("slide34");
      case "slide-33":
        return slidesSettings.get("slide33");
      case "slide-32":
        return slidesSettings.get("slide32");
      case "slide-31":
        return slidesSettings.get("slide31");
      case "slide-24-ape":
        return slidesSettings.get("slide24");
      case "slide-24":
        return slidesSettings.get("slide24");
      case "slide-23":
        return slidesSettings.get("slide23");
      case "slide-21":
        return slidesSettings.get("slide21");
      case "slide-20":
        return slidesSettings.get("slide20");
      case "slide-18":
        return slidesSettings.get("slide18");
      case "slide-17":
        return slidesSettings.get("slide17");
      case "slide-16":
        return slidesSettings.get("slide16");
      case "slide-15":
        return slidesSettings.get("slide15");
      case "slide-13":
        return slidesSettings.get("slide13");
      case "slide-12":
        return slidesSettings.get("slide12");
      case "stocks":
        return slidesSettings.get("slide14");
      case "ap-annual-production-ape":
        return slidesSettings.get("slide11");
      case "ap-annual-production":
        return slidesSettings.get("slide11");
      case "ap-annual-area-ape":
        return slidesSettings.get("slide10");
      case "ap-annual-area":
        return slidesSettings.get("slide10");
      case "annual-crop-production-ape":
        return slidesSettings.get("slide9");
      case "annual-crop-production":
        return slidesSettings.get("slide9");
      case "annual-crop-area-ape":
        return slidesSettings.get("slide8");
      case "annual-crop-area":
        return slidesSettings.get("slide8");
      case "aquarium-crop-value":
        return slidesSettings.get("slide7");
      case "aquarium-production-ape":
        return slidesSettings.get("slide4");
      case "aquarium-production":
        return slidesSettings.get("slide4");
      case "aquarium-area-ape":
        return slidesSettings.get("slide3");
      case "aquarium-area":
        return slidesSettings.get("slide3");
      case "lead-countries-major-crops-population-forecast":
        return slidesSettings.get("slide26");
      case "lead-countries-major-crops-population":
        return slidesSettings.get("slide25");
      case "lead-countries-major-crops-forecast-ape":
        return slidesSettings.get("slide6");
      case "lead-countries-major-crops-forecast":
        return slidesSettings.get("slide6");
      case "world-overview-major-crops-forecast-ape":
        return slidesSettings.get("slide5");
      case "world-overview-major-crops-forecast":
        return slidesSettings.get("slide5");
      case "lead-countries-major-crops-ape":
        return slidesSettings.get("slide2");
      case "lead-countries-major-crops":
        return slidesSettings.get("slide2");
      case "world-overview-major-crops-ape":
        return slidesSettings.get("slide1");
      case "world-overview-major-crops":
        return slidesSettings.get("slide1");
      default:
        return null;
    }
  }, [reportId]);
  return <>{SettingsComponent}</>;
};
